/* v8 ignore start */
import {LottieAnimatedPropertyModel} from "@/lib/lottie/animatedProperties/lottieAnimatedPropertyModel";
import {LottieKeyFrameModel} from "@/lib/lottie/animatedProperties/lottieKeyframeModel";

export class LottieValueModel extends LottieAnimatedPropertyModel<number, LottieValueModel.TJson> {
  public changeValue(value: number): this {
    if (!this.json.a) {
      return this.update({k: value});
    } else {
      return this.update({k: this.json.k.map((keyframe) => ({...keyframe, s: [value]}))});
    }
  }

  public forceAnimateWithKeyFrames(keyframes: LottieKeyFrameModel.IJson[]): this {
    if (!this.json.a) {
      return this.update({a: 1, k: keyframes});
    } else {
      return this.update({a: 1, k: [...this.json.k, ...keyframes]});
    }
  }

  public adjustTimingBy(factor: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t * factor}))});
  }

  public offsetTimingBy(offset: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t + offset}))});
  }
}

export namespace LottieValueModel {
  export type TJson = LottieAnimatedPropertyModel.TJson<number>;
}
/* v8 ignore stop */
